// @flow
import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import Modal from 'brastrap/common/modal/Modal';
import InlineShopFinder from './ShopFinderInline';
import type { ShopFinderProps as Props } from './shop-finder.types';

const messages = defineMessages({
  close: { id: 'actions.close', defaultMessage: 'Close' },
});

const ShopFinder = (props: Props) => {
  const {
    isOpen,
    onClose,
    displayInModal,
    intl: { formatMessage, locale },
    ...rest
  } = props;

  const dismissIcon = {
    icon: {
      icon: 'dismiss',
      label: formatMessage(messages.close),
      labelled: 'after',
    },
  };

  return displayInModal ? (
    <Modal
      modifiers={['shop-finder']}
      isOpen={isOpen}
      actions={{ dismiss: { ...dismissIcon, onClick: onClose } }}
    >
      <InlineShopFinder {...rest} displayInModal />
    </Modal>
  ) : (
    locale !== 'en-US' && <InlineShopFinder {...rest} />
  );
};

ShopFinder.defaultProps = {
  displayTitle: true,
  isOpen: false,
  onClose: () => {},
  displayInModal: false,
};

export default injectIntl(ShopFinder);
